import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Funnel } from "@phosphor-icons/react";

export const FunnelWidget = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get("/dashboard/funnel").then(r => setData(r.data));
  }, []);

  const maxCount = Math.max(...data.map(d => d.count), 1);

  return (
    <div data-testid="funnel-widget">
      <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-[#5C5E66] mb-3">
        <Funnel size={14} weight="bold" className="text-[#FF9900]" /> Conversion Funnel
      </div>
      <div className="bg-white border border-[#E2E2E5] p-5">
        <div className="space-y-2">
          {data.map((row, idx) => {
            const widthPct = (row.count / maxCount) * 100;
            return (
              <div key={row.label} className="flex items-center gap-3" data-testid={`funnel-row-${idx}`}>
                <div className="w-44 text-xs text-[#5C5E66] flex-shrink-0">{row.label}</div>
                <div className="flex-1 relative h-8 bg-[#F7F7F8] border border-[#E2E2E5]">
                  <div
                    className="absolute inset-y-0 left-0 bg-[#006CFF]"
                    style={{ width: `${Math.max(widthPct, 2)}%`, opacity: 0.85 - idx * 0.1 }}
                  />
                  <div className="absolute inset-0 flex items-center justify-between px-2">
                    <span className="font-mono font-semibold text-sm tabular-nums text-white mix-blend-difference">{row.count}</span>
                    {row.conversion_pct !== null && (
                      <span className="font-mono text-[10px] uppercase tracking-wider text-[#0A0B0F] bg-white/80 px-1.5 py-0.5">{row.conversion_pct}% conv</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
          {data.length === 0 && <div className="text-center py-6 text-xs text-[#5C5E66]">No funnel data</div>}
        </div>
      </div>
    </div>
  );
};
